import React, {useContext, useEffect, useRef, useState} from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    Container,

} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {getUserProfile, updateUser, uploadImage} from "../API/User";
import {AlertContext} from "../App/App";
import LocalLoader from "../Loaders/LocalLoader";
import {UserAvatar} from "./UserAvatar";


export const UserProfile = ({client, setClient}) => {
    const navigate = useNavigate();
    const {setSystemAlert} = useContext(AlertContext);
    const saveRef = useRef();
    const [userProfile, setUserProfile] = useState({
        // email: '',
        name: '',
        phone: '',
        picture: '',
    });

    const [loading, setLoading] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);

    useEffect(() => {
        setLoading(true);
        getUserProfile().then((data) => {
            if (!data.picture) data.picture = client.picture;
            setUserProfile(data);
            setLoading(false);
        })
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 's') {
                saveRef?.current?.click();
                event.preventDefault();
            }
        }

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [])

    const handleChange = (event) => {
        setHasChanges(true);
        const { name, value } = event.target;
        setUserProfile({ ...userProfile, [name]: value });
    };

    const handleProfilePictureChange = (event) => {
        setLoading(true);
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = async () => {
                await uploadImage(reader.result)
                setUserProfile({ ...userProfile, picture: reader.result })
                setLoading(false);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleSubmit = async (event) => {
        setLoading(true)
        event.preventDefault();
        const {name, phone} = userProfile;
        await updateUser({name, phone})
        // setSystemAlert({msg: 'Saved', type: 'success', duration: 1000})
        setHasChanges(false);
        setLoading(false)
    };


    return (
        <Container>
            <LocalLoader open={loading}/>
            <Box mt={4} display="flex" flexDirection="column" alignItems="center">
                <Typography component="h1" variant="h5" color="primary">
                    User Profile
                </Typography>
                <input
                    type="file"
                    id="profile-picture-input"
                    style={{ display: 'none' }}
                    onChange={handleProfilePictureChange}
                />

                <UserAvatar
                    picture={userProfile.picture}
                    sx={{ width: 100, height: 100, mt: 2, mb: 2, cursor: 'pointer' }}
                    onClick={() => document.getElementById('profile-picture-input').click()}
                    />

                <Box component="form" noValidate autoComplete="off">
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="Name"
                        name="name"
                        value={userProfile.name || ''}
                        onChange={handleChange}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        disabled={true}
                        id="email"
                        label="Email Address"
                        name="email"
                        value={client.email || ''}
                        onChange={handleChange}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="phone"
                        label="Phone Number"
                        name="phone"
                        value={userProfile.phone || ''}
                        onChange={handleChange}
                    />
                        <Button
                                variant={hasChanges ? 'contained' : 'outlined'}
                                fullWidth
                                disabled={loading}
                                color="secondary"
                                style={{marginBottom: '16px'}}
                                sx={{ mt: 3, mb: 2 }}
                                onClick={handleSubmit}
                                ref={saveRef}
                        >
                            Save
                        </Button>
                </Box>
            </Box>
        </Container>
    );
};
